import { useStore } from 'stores';
import { TABS } from 'constants/tabs';
import TabList from 'components/TabList';
import AllStock from 'components/AllStock';
import Strategy from 'components/Strategy';

function Content() {
  const currentTab = useStore((state) => state.currentTab);
  const setCurrentTab = useStore((state) => state.setCurrentTab);
  const isLogin = useStore((state) => state.isLogin);

  function handleTabClick(tab) {
    if (tab.key === currentTab.key) {
      return;
    }

    setCurrentTab(tab);
  }

  return (
    <div className="sm:max-w-screen-xs pb-6 w-full">
      <h3 className="text-center text-2xl m-6 font-semibold text-gray-dark">{currentTab.name}</h3>

      {isLogin && (
        <TabList handleTabClick={(tab) => handleTabClick(tab)} currentTabKey={currentTab.key} />
      )}

      {currentTab.key === TABS.ALL_STOCK.key && <AllStock />}
      {currentTab.key === TABS.STRATEGY.key && <Strategy />}
    </div>
  );
}

export default Content;
